// Base URL for assets (handles /deadsector/ in production)
export const ASSET_BASE = import.meta.env.BASE_URL || '/';

// Helper function to get asset path
export function assetPath(path) {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${ASSET_BASE}${cleanPath}`;
}

// Game dimensions
export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;

// Game constants
export const PLAYER_SPEED = 150;
export const ZOMBIE_SPEED_SHAMBLER = 40;
export const ZOMBIE_SPEED_CRAWLER = 100;

// Homing rocket constants
export const ROCKET_SPEED = 300;
export const BLAST_RADIUS = 48; // ~1.5 zombie widths
export const ROCKET_LIFETIME = 5000; // ms before auto-explode
export const HOMING_ROCKETS_MAX = 3;
export const ROCKET_PICKUP_CHANCE = 0.2; // 20% chance to drop on zombie kill

// Colors (80s palette)
export const COLORS = {
  NEON_PINK: 0xff00ff,
  NEON_CYAN: 0x00ffff,
  NEON_GREEN: 0x39ff14,
  BLOOD_RED: 0x8b0000,
  VHS_WHITE: 0xf0f0f0,
  DARK_PURPLE: 0x1a1a2e,
};
